/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionpreviewheading2Inputs */

const en_actionpreviewheading2 = /** @type {(inputs: Actionpreviewheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the push`)
};

const de_actionpreviewheading2 = /** @type {(inputs: Actionpreviewheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So sieht die Mitteilung aus`)
};

/**
* | output |
* | --- |
* | "This is the push" |
*
* @param {Actionpreviewheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionpreviewheading2 = /** @type {((inputs?: Actionpreviewheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionpreviewheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionpreviewheading2(inputs)
	return de_actionpreviewheading2(inputs)
});
export { actionpreviewheading2 as "actionPreviewHeading" }